export function processFormData (inputs) {
  var data = new window.FormData()
  for (let i = 0; i < inputs.length; i++) {
    let type = inputs[i].type
    if (type !== 'file' && type !== 'checkbox' && type !== 'submit') {
      data.append(inputs[i].name, inputs[i].value)
    } else if (type === 'file') {
      appendFiles(inputs[i], data)
    } else if (type === 'checkbox') {
      if (inputs[i].checked) {
        data.append(inputs[i].name, inputs[i].value)
      }
    }
  }
  return data
}

function appendFiles (input, formData) {
  var files = input.files
  for (let key in files) {
    if (files.hasOwnProperty(key) && (files[key] instanceof window.File)) {
      formData.append(input.name, files[key])
    }
  }
}
